module.exports = __webpack_public_path__ + "img/album08_02.d02e5335.jpg";